import { getIdTokenResult, onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth";

import { configuration } from "./configuration";
import { getAdminAuth, getAdminFunctions, waitForAdminAuth } from "./firebase";

import type { AdminSessionSubscriber } from "./auth.types";

const DEMO_USER = { id: "demo-platform-admin", email: "admin@tayan.app" };

export const subscribeToAdminSession = (subscriber: AdminSessionSubscriber): (() => void) => {
  if (configuration.mode === "demo") {
    subscriber({ status: "ready", user: DEMO_USER, message: null });
    return () => undefined;
  }
  subscriber({ status: "loading", user: null, message: null });
  let active = true;
  const unsubscribe = onAuthStateChanged(getAdminAuth(), (user) => {
    void (async () => {
      if (!user) {
        subscriber({ status: "signed-out", user: null, message: null });
        return;
      }
      try {
        const token = await getIdTokenResult(user, true);
        if (!active) return;
        if (token.claims.platformAdmin !== true) {
          subscriber({
            status: "forbidden",
            user: { id: user.uid, email: user.email },
            message: "Bu hesapta platformAdmin yetkisi bulunmuyor.",
          });
          return;
        }
        // Initialize App Check only after the privileged claim is confirmed.
        getAdminFunctions();
        subscriber({ status: "ready", user: { id: user.uid, email: user.email }, message: null });
      } catch {
        if (active) subscriber({ status: "forbidden", user: null, message: "Yönetici oturumu doğrulanamadı." });
      }
    })();
  });
  return () => {
    active = false;
    unsubscribe();
  };
};

export const signInAdmin = async (email: string, password: string): Promise<void> => {
  await waitForAdminAuth();
  await signInWithEmailAndPassword(getAdminAuth(), email.trim(), password);
};

export const signOutAdmin = async (): Promise<void> => {
  if (configuration.mode === "demo") return;
  await signOut(getAdminAuth());
};
